import styled from 'styled-components';

export const SubmissionMenuWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid #ced4da;
  background: #fff;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  padding: 8px;
`;

export const SubmissionMenuItem = styled.button`
  width: 110px;
  display: flex;
  padding: 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 8px;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f1f3f5;
  }
`;
